import React, { useState } from "react";
import styled from "styled-components";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { FieldArray } from "react-final-form-arrays";

import { Button, Icon } from "../../common";

import { DetailList, DetailSelectModal } from "./";

const Wrapper = styled.div`
  padding: 0 20px;
`;

const Actions = styled.div`
  display: flex;
  flex-direction: row;
  & ${Button} {
    margin: 0 5px;
  }
  margin-bottom: 15px;
`;

const Details = styled.div``;

const DroppableContainer = styled.div``;

export const ProductDetails = ({
  defaultDetails,
  //orderDetails,
  setOrderDetails,
  storeId,
}) => {
  //console.log(defaultDetails)
  const [detailsOpened, setDetailsOpened] = useState(0);
  const [details, setDetails] = useState(defaultDetails || []);
  const [detailSelectModalOpen, setDetailSelectModalOpen] = useState(false);

  const handleDetailDrag = (fields) => (result) => {
    if (result.destination) {
      fields.swap(result.source.index, result.destination.index);
      const newDetails = [...details];
      const aux = newDetails[result.destination.index];
      newDetails[result.destination.index] = newDetails[result.source.index];
      newDetails[result.source.index] = aux;
      for (let i = 0; i < newDetails.length; i++) {
        newDetails[i].order = i + 1;
      }

      //console.log(newDetails)
      setOrderDetails(newDetails);
      setDetails(newDetails);
    }
  };

  const toggleDetails = (isOpen) => {
    if (isOpen) {
      setDetailsOpened(detailsOpened + 1);
    } else {
      setDetailsOpened(detailsOpened - 1);
    }
  };

  const toggleDetailSelectModal = () => {
    setDetailSelectModalOpen(!detailSelectModalOpen);
  };

  const handleAddNewGroup = (fields) => () => {
    const newGroup = {
      name: "",
      min: 0,
      max: 0,
      isCheckbox: false,
      items: [],
      order: details.length + 1,
    };
    fields.push(newGroup);
    details.push(newGroup);
    setDetails(details);
  };

  const handleSelectGroup = (fields) => (group) => {
    fields.push(group);
    details.push(group);
    setDetails(details);
  };

  const handleRemoveGroup = (fields, index) => () => {
    if (window.confirm("Tem certeza que deseja remover este grupo?")) {
      fields.remove(index);
      details.splice(index, 1);
      setDetails(details);
    }
  };

  const isDragEnabled = detailsOpened === 0;
  return (
    <Wrapper>
      <FieldArray
        name={`details`}
        initialValue={details}
        subscription={{ submitting: true }}
      >
        {({ fields }) => (
          <>
            <Actions>
              <Button
                type="button"
                className="primary"
                onClick={handleAddNewGroup(fields)}
              >
                <Icon name="plus" /> Novo grupo
              </Button>
              <Button
                type="button"
                className="primary"
                onClick={toggleDetailSelectModal}
              >
                <Icon name="download" /> Usar existente
              </Button>
            </Actions>
            <Details>
              <DragDropContext onDragEnd={handleDetailDrag(fields)}>
                <Droppable type="detail" droppableId="droppableDetail">
                  {(provided, snapshot) => (
                    <DroppableContainer
                      {...provided.droppableProps}
                      ref={provided.innerRef}
                    >
                      {fields.map((field, i) => {
                        const detail = (details && details[i]) || {};
                        return (
                          <DetailList
                            field={field}
                            isDragEnabled={isDragEnabled}
                            index={i}
                            detail={detail}
                            onToggleDetail={toggleDetails}
                            onDelete={handleRemoveGroup(fields, i)}
                            storeId={storeId}
                          />
                        );
                      })}
                      {provided.placeholder}
                    </DroppableContainer>
                  )}
                </Droppable>
              </DragDropContext>
            </Details>
            <DetailSelectModal
              isOpen={detailSelectModalOpen}
              onClose={toggleDetailSelectModal}
              onSelect={handleSelectGroup(fields)}
              storeId={storeId}
            />
          </>
        )}
      </FieldArray>
    </Wrapper>
  );
};
